import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=3823cdb0&scoped=true&"
import script from "./disclaimer.vue?vue&type=script&lang=js&"
export * from "./disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=3823cdb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823cdb0",
  null
  
)

export default component.exports